// Pre-installed database for names and items
export const PREDEFINED_NAMES = [
  'Anna', 'Anne H', 'Bongo', 'David', 'Graeme', 'Jane', 'Jim', 'Kate', 'Kath', 'Kiersten', 'Linda', 'Michael', 'Nicola', 'Richard D', 'Richard H', 'Sarah', 'Sean', 'Sharon'
];

export const PREDEFINED_ITEMS = [
  { name: 'Beer', price: 2.70, category: 'Drinks' },
  { name: 'Cocktail', price: 5.00, category: 'Drinks' },
  { name: 'Coffee', price: 1.40, category: 'Drinks' },
  { name: 'Shandy', price: 2.70, category: 'Drinks' },
  { name: 'Soft Drink', price: 2.70, category: 'Drinks' },
  { name: 'Spirit', price: 5.00, category: 'Drinks' },
  { name: 'Tea', price: 1.40, category: 'Drinks' },
  { name: 'Tinto de Verano', price: 2.70, category: 'Drinks' },
  { name: 'Wine', price: 2.70, category: 'Drinks' }
];

// Helper functions
export const searchNames = (query) => {
  if (!query) return PREDEFINED_NAMES;
  return PREDEFINED_NAMES.filter(name => 
    name.toLowerCase().includes(query.toLowerCase())
  );
};

export const searchItems = (query) => {
  if (!query) return PREDEFINED_ITEMS;
  return PREDEFINED_ITEMS.filter(item => 
    item.name.toLowerCase().includes(query.toLowerCase()) ||
    item.category.toLowerCase().includes(query.toLowerCase())
  );
};

export const getItemByName = (name) => {
  if (!name || typeof name !== 'string') {
    return null;
  }
  return PREDEFINED_ITEMS.find(item => 
    item.name.toLowerCase() === name.toLowerCase()
  );
};
